// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__v43HU","loading":"Loading_loading__P31NE"};